import React, { useEffect } from "react";
import { FormLogin } from "../../containers/FormLogin/FormLogin";
import "./Login.css";
import imagen from "../../assets/img1.jpeg";
function Login() {
  useEffect(() => {
    const height = document.getElementsByClassName("column-rigth")[0];
    const element = document.getElementsByClassName("login-img")[0];

    new Promise((resolve) =>
      setTimeout(() => {
        element.style.height = height.clientHeight + "px";
        resolve(true);
      }, 10)
    );
  });

  return (
    <div className="Login container-animated">
      <div className="login-container">
        <div className="container">
          <div className="column-left box">
            <div className="login-img">
              <div className="img-container">
                <img src={imagen} />
              </div>
            </div>
          </div>
          <div className="column-rigth box">
            <FormLogin />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
